import React from 'react';
import { useTranslation } from 'react-i18next';
import DownArrow from '../../../../../assets/DownArrow';

import { DefaultPropertyType, FilterType } from '../../../../../interface';
import {
	AllCountry,
	Instances,
	TimeDropDownOptions,
} from '../../../../../constants';

import CountryDropDown from '../../../atoms/CountryDropDown';
import WidgetDropDown from '../../../molecules/DropDown/Dropdown';
import HeaderTemplate from '../../../templates/Header';
import DownloadButton from '../../../molecules/Download';

type HeaderPropsType = {
	filters: FilterType;
	showDownload?: boolean;
	instanceId?: Instances;
	message?: string;
	onFilterChange: (filters: FilterType) => void;
	setFilterKey: (filterKey: string) => void;
};

const Header: React.FC<HeaderPropsType> = ({
	filters,
	showDownload,
	instanceId,
	message,
	onFilterChange,
	setFilterKey
}) => {
	const { t } = useTranslation();

	const getDropdown = (
		options: Array<DefaultPropertyType>,
		onClick?: (data: any) => void,
		selectedItem?: DefaultPropertyType,
		title?: string
	) => (
			<WidgetDropDown
				title={title}
				trigger={'click'}
				placement={'bottom'}
				items={options}
				label={selectedItem?.label}
				action={onClick}
				icon={<DownArrow height={24} width={24} color={'#1676EE'} />}
			/>
		);

	const getTimeLabel = () => {
		const { timerange } = filters || {};
		const { start_time, end_time } = timerange || {};
		return TimeDropDownOptions.find(({ value }) => {
			const [start, end] = value as Array<string>;
			return start_time === start && end === end_time;
		});
	};

	const memoizedTime = React.useMemo(() => getTimeLabel(), [
		filters?.timerange?.end_time,
		filters?.timerange?.start_time,
	]);

	const onTimeRange = ([start, end, key]: Array<string>) => {
		onFilterChange({
			...filters,
			timerange: {
				start_time: start,
				end_time: end,
			},
		});
		setFilterKey(key)
	};

	const onCountrySelect = (value: any) => {
		onFilterChange({
			...filters,
			country_code: value,
		});
	};

	return (
		<HeaderTemplate title={t('overviewWidget')}>
			<CountryDropDown
				icon={<DownArrow height={24} width={24} color={'#1676EE'} />}
				placement={'bottom'}
				defaultProps={[AllCountry()]}
				selectedValue={filters?.country_code || ''}
				action={onCountrySelect}
			/>
			{getDropdown(TimeDropDownOptions, onTimeRange, memoizedTime)}
			{showDownload && (
				<DownloadButton
					instanceId={instanceId as Instances}
					message={message as string}
					params={filters}
				/>
			)}
		</HeaderTemplate>
	);
};

export default Header;
